import { toPairs, fromPairs, isEmpty } from '@livechat/data-utils';

var buildQueryString = function buildQueryString(obj) {
  return toPairs(obj).map(function (pair) {
    return pair.map(encodeURIComponent).join('=');
  }).join('&');
};

var decodeQueryString = function decodeQueryString(query) {
  var pairs = query.split('&').filter(Boolean).map(function (pair) {
    return pair.split('=').map(function (value) {
      return decodeURIComponent(value.replace('+', '%20'));
    });
  }).map(function (pair) {
    return pair.length === 2 ? pair : [pair[0], ''];
  });
  var decoded = fromPairs(pairs);
  return decoded;
};

var hostnameRegexp = /(?:[^:]+:\/\/)?([^/\s]+)/;
function getHostname(url) {
  var hostnameMatch = url.match(hostnameRegexp);
  return hostnameMatch && hostnameMatch[1];
}

var originRegexp = /[^:]+:\/\/[^(/|?)\s]+/;
var getOrigin = function getOrigin(url) {
  var domain = url.match(originRegexp);
  return domain && domain[0];
};

var searchRegexp = /.*?\?([^#]+)/;
var getSearch = function getSearch(url) {
  var match = url.match(searchRegexp);
  return match ? "?" + match[1] : '';
};

var trimSearch = function trimSearch(search) {
  return search.replace(/^\?/, '');
};

var getQueryParams = function getQueryParams(urlOrSearch) {
  if (getOrigin(urlOrSearch) === null) {
    return decodeQueryString(trimSearch(urlOrSearch));
  }
  var search = trimSearch(getSearch(urlOrSearch));
  return search ? decodeQueryString(search) : {};
};

var getQueryParam = function getQueryParam(name, url) {
  return getQueryParams(url)[name];
};

var pathnameRegexp = /^(?:https?:)?\/\/[^/]+\/([^?#]+)/;
var getPathname = function getPathname(url) {
  var pathname = url.match(pathnameRegexp);
  return "/" + (pathname && pathname[1] || '');
};

// URL can contain leading C0 control or \u0020 SPACE,
// and any newline or tab are filtered out as if they're not part of the URL.
// https://url.spec.whatwg.org/#url-parsing
// Tab or newline are defined as \r\n\t:
// https://infra.spec.whatwg.org/#ascii-tab-or-newline
// A C0 control is a code point in the range \u0000 NULL to \u001F
// INFORMATION SEPARATOR ONE, inclusive:
// https://infra.spec.whatwg.org/#c0-control-or-space
var intersperseWithTabOrNewline = function intersperseWithTabOrNewline(str) {
  return str.replace(/\w/g, '$&[\\r\\n\\t]*');
};
var unsafeProtocol = new RegExp("^[\0-\x1F]*(" + intersperseWithTabOrNewline('javascript') + "|" + intersperseWithTabOrNewline('data') + "):", 'i');
// would be better to filter safe things
// but people might paste in protocolless URLs
// and we would filter them out
var hasUnsafeProtocol = function hasUnsafeProtocol(url) {
  return unsafeProtocol.test(url);
};

var protocolRegexp = /^((http(s)?:)?\/\/)/;
var removeProtocol = function removeProtocol(url) {
  return url.replace(protocolRegexp, '');
};

var protocolRegexp$1 = /^((http(s)?:)?\/\/)/;
var getProtocol = function getProtocol(url) {
  var match = url.match(protocolRegexp$1);
  return match ? match[2] : null;
};

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

var extendURLByQueryParams = function extendURLByQueryParams(url, params) {
  if (Object.keys(params).length === 0) {
    return url;
  }
  var urlOrigin = getOrigin(url);
  var urlPath = getPathname(url);
  var originalParams = getSearch(url) ? getQueryParams(url) : {};
  var extendParams = buildQueryString(_extends({}, originalParams, params));
  if (url.indexOf('#') > -1) {
    return "" + urlOrigin + urlPath + "?" + extendParams + "#" + url.split('#')[1];
  }
  return "" + urlOrigin + urlPath + "?" + extendParams;
};

var removeQueryParams = function removeQueryParams(url, paramsToRemove) {
  if (url.indexOf('?') === -1) {
    return url;
  }
  var params = getQueryParams(url);
  if (isEmpty(params)) {
    return url;
  }
  if (Object.keys(params).every(function (paramKey) {
    return !paramsToRemove.includes(paramKey);
  })) {
    return url;
  }
  paramsToRemove.forEach(function (param) {
    return delete params[param];
  });
  var _url$split = url.split('?'),
    querylessURL = _url$split[0];
  var extendedURL = extendURLByQueryParams(querylessURL, params);
  if (url.indexOf('#') > -1) {
    return extendedURL + "#" + url.split('#')[1];
  }
  return extendedURL;
};

var ensureSecureProtocol = function ensureSecureProtocol(url) {
  return "https://" + removeProtocol(url);
};

export { buildQueryString, decodeQueryString, ensureSecureProtocol, extendURLByQueryParams, getHostname, getOrigin, getPathname, getProtocol, getQueryParam, getQueryParams, getSearch, hasUnsafeProtocol, removeProtocol, removeQueryParams, trimSearch };
